import { Suspense, lazy, useRef } from 'react'
import { Button, Col } from 'react-bootstrap'
import classNames from 'classnames'

import fullscreen from 'assets/icons/fullscreen.svg'
import fullscreenExit from 'assets/icons/fullscreen_exit.svg'
import Img from 'components/ui/Img'
import Loader from 'components/ui/loader/Loader'
import { useFullscreenStatus } from 'helpers'

const PdfReadOnly = lazy(() => import('./PdfReadOnly'))

interface PdfProps {
  url: string
  denyDownload?: boolean
}

const MAX_HEIGHT = '700px'

export const Pdf = ({ url, denyDownload }: PdfProps) => {
  const element = useRef<HTMLIFrameElement>(null)
  const [isFullscreen, setFullscreen] = useFullscreenStatus(element)

  return (
    <div
      className={classNames(
        'bg-white d-flex flex-column',
        isFullscreen && 'h-100'
      )}
      ref={element}
    >
      <div className={'flex-fill overflow-hidden'}>
        <div
          className={'position-relative h-100'}
          onClick={() => {
            isFullscreen && document.exitFullscreen()
          }}
          style={{
            maxHeight: isFullscreen ? '100%' : MAX_HEIGHT,
          }}
        >
          {(denyDownload && (
            <Suspense fallback={<Loader className="my-5" />}>
              <PdfReadOnly url={url} />
            </Suspense>
          )) || (
            <iframe
              title="pdf-iframe"
              src={url}
              width="100%"
              className="border-0"
              height={isFullscreen ? '100%' : MAX_HEIGHT}
            />
          )}
        </div>
      </div>
      <Col xs="auto">
        <div className="d-flex justify-content-center my-2">
          <Button
            className="border-dark"
            variant="outline-light"
            size="sm"
            onClick={() => {
              setFullscreen(!isFullscreen)
            }}
          >
            <Img src={isFullscreen ? fullscreenExit : fullscreen} />
          </Button>
        </div>
      </Col>
    </div>
  )
}

export default Pdf
